import moment from 'moment';

export const PROMOTION = {
    STAR_DATE: "2025-08-06 00:00:00",
    END_DATE: "2025-09-30 23:59:59",
    ICON: '🤓',
    TITLE: '',
    SUBTITLE: 'Back to School cuando tú quieras, 20% OFF en tu plan anual.',
    PROMOTIONAL_CODE: 'BACK2025',
    URL_UTM: 'https://www.talisis.com/membresias?utm_campaign=Cybermonday&utm_source=banner',
    membership:{
        title:'Usa el código',
        promotion_code: 'BACK2025',
        title_2:'y disfruta 20% de descuento en cualquier membresía con',
        subtitle:'periodo anual.',
    },
    showCountdown:false
};


const today = moment();
const endDate = moment(PROMOTION.END_DATE).add(1, 'days');

export const ACTIVATE_COUNTDOWN = moment().isSameOrAfter(moment(PROMOTION?.STAR_DATE, 'YYYY-MM-DD HH:mm:ss')) &&
    moment().isSameOrBefore(moment(PROMOTION?.END_DATE, 'YYYY-MM-DD HH:mm:ss'))
